import _isEmpty from 'lodash/isEmpty';
import { Button, Tooltip } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { setIsOpenAnswersDeleteModal, setIsOpenMarkAsSentModal } from '@actions/answersPageAction';
import { SentMessageIcon, TrashIcon } from '@images/icons';
import { translate } from '@utils';
import { checkedAnswersSelector } from '@selectors/answer';
import { hasPermissionFeature } from '@hooks/hasPermissionFeature';
import { FeaturePermission, PagePermission, PermissionActions } from '@enums';

export const AnswerControllers = () => {
  const dispatch = useDispatch();

  const checkedAnswers = useSelector(checkedAnswersSelector);
  const canRemoveAnswers = hasPermissionFeature(
    PagePermission.Answers,
    [FeaturePermission.AnswerTable],
    [PermissionActions.Remove]
  );
  const canUpdateAnswers = hasPermissionFeature(
    PagePermission.Answers,
    [FeaturePermission.AnswerTable],
    [PermissionActions.Update]
  );
  return (
    <>
      {canRemoveAnswers && (
        <Tooltip title={translate('delete')} arrow>
          <span>
            <Button
              onClick={() => dispatch(setIsOpenAnswersDeleteModal(true))}
              disabled={_isEmpty(checkedAnswers)}
              disableRipple
              data-testid="delete-button"
            >
              <TrashIcon />
            </Button>
          </span>
        </Tooltip>
      )}

      {canUpdateAnswers && (
        <Tooltip
          title={
            checkedAnswers.length > 1
              ? translate('mark_as_sent_several')
              : translate('mark_as_sent_one')
          }
          arrow
        >
          <span>
            <Button
              onClick={() => dispatch(setIsOpenMarkAsSentModal(true))}
              disabled={
                _isEmpty(checkedAnswers) ||
                checkedAnswers.every((answer) => answer?.status === 'sent')
              }
              disableRipple
            >
              <SentMessageIcon />
            </Button>
          </span>
        </Tooltip>
      )}
    </>
  );
};
